<template>
  <div id="MainWrapper">
     <article  class="padd-tb55">
       <div class="container">
         <div class="row">
           <div class="col-md-12">
                <h1 class="font-bold  mar-no blue-c-3">Terms and Conditions</h1>

                <p class="padd-t30 font-regular justify">This terms and conditions ("Terms", "Agreement") is an agreement between Daniel 14, LLC (“DanAdvance”, "Website", "us", "we" or "our") and you ("User", "you" or "your"). This Agreement sets forth the general terms and conditions of your use of the danadvance.com website and any of its products or services (collectively, "Website" or "Services").</p>

                <h3 class="blue-c-3">Use of Contents</h3>
                <p class="font-regular justify">This Website provides its contents for informational purposes only. It does not constitute a commitment to provide you with a loan, carry out underwriting service of any proposed transaction, purchase any assets, provide or arrange funding, or provide any other services. It is the User’s responsibility to determine the accuracy, completeness, and benefit of any content this Website provides. Your continued use of the Website constitutes your acceptance of these Terms and Conditions, and your acknowledgement that you will bear all risks and responsibilities associated with the use of such content.</p>

                <p class="padd-t20 font-regular justify">The content of this Website should not be considered as advice on investment, tax, or legal matters. Any decisions made by the User based on information contained on this Website will solely be the responsibility of the User. The User should always consult its business, investment, legal, and/or tax and accounting advisors prior to making any transactions relevant to the information provided in this Website.</p>

                <h3 class="blue-c-3">Links to other websites</h3>
                <p class="font-regular justify">Although this Website may be linked to other websites, we are not, directly or indirectly, implying any approval, association, sponsorship, endorsement, or affiliation with any linked website, unless specifically stated herein. We are not responsible for examining or evaluating, and we do not warrant the offerings of, any businesses or individuals or the content of their websites. We do not assume any responsibility or liability for the actions, products, services, and content of any other third-parties. You should carefully review the legal statements and other conditions of use of any website which you access through a link from this Website. Your linking to any other off-site websites is at your own risk.</p>

                <h3 class="blue-c-3">Changes and amendments</h3>
                <p class="font-regular justify">We reserve the right to modify this Agreement or its policies relating to the Website or Services at any time, effective upon posting of an updated version of this Agreement on the Website. When we do we will revise the updated date at the bottom of this page. Continued use of the Website after any such changes shall constitute your consent to such changes. 
                Acceptance of these terms</p>

                <p class="padd-t20 font-regular justify">You acknowledge that you have read this Agreement and agree to all its terms and conditions. By using the Website or its Services you agree to be bound by this Agreement. If you do not agree to abide by the terms of this Agreement, you are not authorized to use or access the Website and its Services.</p>

                <h3 class="blue-c-3">Contacting us</h3>
                <p class="font-regular justify">If you have any questions about this Agreement, please contact us.</p>
                <p class="font-regular justify">This document was created with WebsitePolicies.com and was last updated on April 3, 2019</p>
           </div>
         </div> 
       </div>
     </article>
     <rwv-CTA></rwv-CTA>
  </div> 
</template>
<script>
import * as $ from 'jquery'

import RwvSubbanner from '@/components/Subbanner'
import RwvCTA from '@/components/CTA'
export default {
  name: 'Home',
  data: function() {
    return {
      title: 'Dan Advance | Terms & Conditions',
      tag:'More than just a reliable rate of return!',
    }
  },
  mounted() {
   
  },
  components: { RwvSubbanner,RwvCTA}
}
</script>


// WEBPACK FOOTER //
// src/views/Terms.vue